export default function ({
    companyId = this.companyId || this.$store.getters.companyId,
    appId = this.appId || this.$store.getters.appId,
    modKey = this.modKey,
    reportKey = this.reportKey
}) {
    return {
        system: {
        },
        file: {
            ossToken: `/proxy/file/${companyId}/FileAction/apaas-files/ossToken`,
            editorOssToken: `/proxy/file/${companyId}/FileAction/apaas-upload/ossToken`,
            fileIndex: `/proxy/core/${appId}/FileArchive/memberAll`, // 文件夹
            getFiles: `/proxy/custom/${companyId}/${appId}/FileAction/file/getFiles` // 文件
        },
        company: {
            compDepartIndex: `/proxy/comp/${companyId}/Department/compIndex`,
            userIndex: `/proxy/comp/${companyId}/Company/getCompanyUsers`
        },
        // app - 菜单
        app: {
            memberShow: `/proxy/core/${appId}/InnerApp/memberShow`
        },
        // 工作表
        sheet: {
            schema: `/proxy/core/${appId}/xMod/schema`, // 可能不一定内部表单（Mod），也可能是外部数据, memberGetByKey改名成通用的schema
            index: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customIndex`,
            default: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customDefault`,
            all: `/proxy/core/${appId}/Mod/appAll`, // 获取所有工作表 // TODO: 待确定删除么

            groupIndex: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customGroup`,
            create: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customCreate`,
            show: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customShow`,
            update: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customUpdate`,
            delete: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customSearchDelete`,
            searchUpdate: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customSearchUpdate`,
            refBatchUpdate: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customRefBatchUpdate`,
            customCalculate: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customCalculate`,
            customLog: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customlog`,
            customCopy: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/customCopy`,
            exportTemplate: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/exportTemplate`,
            exportExcel: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/exportExcel`,
            importExcel: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/importExcel`,
            getJobStatus: "/proxy/job/JobAction/getJobStatus"
        },
        // flatTable
        flatTable: {
            exportTemplate: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/exportFlatTemplate`,
            exportExcel: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/exportFlatTableExcel`,
            importExcel: `/proxy/custom/${companyId}/${appId}/xMod/${modKey}/importFlatTableExcel`
        },
        // 自定义页
        custom: {
            schema: `/proxy/core/${appId}/Tabulation/schema`
        },
        // 自定义页面
        Report: {
            memberShow: `/proxy/core/${appId}/Report/memberShow`,
            download: `/proxy/custom/${companyId}/${appId}/Report/${reportKey}/data/generate`
        },
        // 嵌入页面
        EmbedPage: {
            memberGetByKey: `/proxy/core/${appId}/EmbedPage/memberShow`
        },
        // 仪表盘
        Dashboard: {
            memberShow: `/proxy/core/${appId}/Dashboard/memberShow`,
            // 此modKey,为 InnerChart， InnerTable的key
            getChartData: `/proxy/custom/${companyId}/${appId}/InnerChart/${modKey}/getData`,
            getSeriesData: `/proxy/custom/${companyId}/${appId}/InnerChart/${modKey}/getSeriesData`,
            getTableData: `/proxy/custom/${companyId}/${appId}/InnerTable/${modKey}/getData`,

            exportSeriesData: `/proxy/custom/${companyId}/${appId}/InnerChart/${modKey}/exportSeriesData`, // 导出图表类
            exportInnerTable: `/proxy/custom/${companyId}/${appId}/InnerTable/${modKey}/exportInnerTable` // 导出table类
        },
        Flow: {
            memberAll: `/proxy/core/${appId}/FlowDef/memberAll`,
            conditionsTypes: `/proxy/core/${appId}/FlowDef/conditionsTypes`
        },
        // 流程实例列表
        flowInst: {
            adminAll: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/adminAll`,
            adminDeleteAll: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/adminDeleteAll`,

            memberAll: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/memberAll`,
            show: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/flowInstShow`,
            memberDelete: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/memberDeleteAll`,
            subFlowAll: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/subFlowAll`,
            chart: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/chart`,
            changeLog: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/changeLog`,
            opinionList: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/opinionList`,

            getTabNotify: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/getTabNotify`,
            ignoreTabNotify: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/ignoreTabNotify`
        },
        // 流程实例编辑
        approve: {
            index: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/getFlowTask`,
            taskCount: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/getFlowTaskCount`,
            notifyIndex: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/getFlowNotify`,
            startFlow: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/startFlow`,
            // default: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskDefault`,
            show: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskShow`,
            startFlowSave: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/startFlowSave`,
            save: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskSave`,
            startFlowPush: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/startFlowPush`,
            push: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskPush`,
            reject: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskReject`,

            completeAllNotify: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/completeAllNotify`, // 清空未读/一键已读
            taskCalculate: `/proxy/custom/${companyId}/${appId}/FlowInst/flow/taskCalculate` // 计算
        },
        share: {
            createLink: `/proxy/${companyId}/${appId}/ShareLogs/app_create`
        },
        AppRole: {
            memberAll: `/proxy/core/${appId}/AppRole/memberAll`
        },
        userRole: {
            all: `/proxy/core/${appId}/AppRole/allRole`,
            update: `/proxy/core/${appId}/AppRole/memberUpdate`
        },
        // 分组-只应用下用
        appItemGroup: {
            memberAll: `/proxy/core/${appId}/AppItemGroup/memberAll`
        }

    };
};



// WEBPACK FOOTER //
// ./src/data/system/httpPathMap.js